import { computed, action, isObservableArray } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { ICapabilitiesConfiguration } from '../models';
import { IQueryOptions } from '../../../models/commonTypes';

export class CapabilitiesStore extends StoreBase {
	static componentKey: 'capabilities' = 'capabilities';

	@computed
	get configuration(): ICapabilitiesConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(CapabilitiesStore.componentKey);
		}
	}

	@action
	async initialize(): Promise<void> {

	}

	@computed
	get queryOptions(): IQueryOptions | undefined {
		return this.configuration && this.configuration.query;
	}

	@computed
	get capabilities(): string[] {
		if (this.queryOptions) {
			const response = this.getQueryValue(this.queryOptions);
			if (!Array.isArray(response) && !isObservableArray(response)) {
				return [response];
			}
			return response;
		}
		return [];
	}
}